import gql from 'graphql-tag';

export const CREATE_COMMENT = gql`
  mutation createComment ($data: CommentsInput!) {
    createComment (data: $data) {
      id
      message
      entity
      entityName
    }
  }
`;